import { applyMiddleware, combineReducers, createStore, Reducer } from "redux";
import createSagaMiddleware                                       from 'redux-saga';
import { connectRouter, routerMiddleware, RouterState }           from 'connected-react-router'
import { createBrowserHistory }                                   from "history";
import { composeWithDevTools }                                    from 'redux-devtools-extension';

import APIReducer       from "./API/reducer";
import cameraReducer    from "./cameras/reducer";
import layoutsReducer   from "./layouts/reducer";
import timelineReducer  from "./timeline/reducer";
import settingsReducer  from "./settings/reducer";
import recordingReducer from "./recordings/reducer";
import bookmarkReducer  from "./bookmarks/reducer";
import browseReducer    from "./browse/reducer";
import alertsReducer    from "./alerts/reducer";

import { APIState }       from "./API/types";
import { CamerasState }   from "./cameras/types";
import { LayoutState }    from "./layouts/types";
import { TimelineState }  from "./timeline/types";
import { SettingsState }  from "./settings/types";
import { RecordingState } from "./recordings/types";
import rootSaga           from './sagas';
import { BookmarkState }  from "./bookmarks/types";
import { BrowseState }    from "./browse/types";
import { AlertState }     from "./alerts/types";

export interface ApplicationState {
  router: RouterState,
  API: APIState,
  cameras: CamerasState,
  layouts: LayoutState,
  timeline: TimelineState,
  settings: SettingsState,
  recording: RecordingState,
  bookmarks: BookmarkState,
  browse: BrowseState,
  alerts: AlertState
}


export const history = createBrowserHistory({basename: `${process.env.PUBLIC_URL}`});
const sagaMiddleware = createSagaMiddleware();

const reducers: Reducer<ApplicationState> = combineReducers({
  router: connectRouter(history),
  API: APIReducer,
  cameras: cameraReducer,
  settings: settingsReducer,
  layouts: layoutsReducer,
  timeline: timelineReducer,
  recording: recordingReducer,
  bookmarks: bookmarkReducer,
  browse: browseReducer,
  alerts: alertsReducer
});

const composeEnhancers = composeWithDevTools({trace: true, traceLimit: 50})

const enhancer = composeEnhancers(applyMiddleware(routerMiddleware(history), sagaMiddleware));

const store = createStore(reducers, enhancer);
sagaMiddleware.run(rootSaga);
//@ts-ignore
window.store = store;


export default store

